// Projects shown on the portfolio. Card layout: name, blurb, tags, github, demo (optional).
// TODO: swap in real GitHub URLs for AI Resume Tailor, Aural Eyes, and Carun before pushing live.
export const projects = [
  {
    name: "AI Resume Tailor",
    blurb:
      "Tailors a resume to any job description using a RAG pipeline, surfacing the most relevant experience in one pass.",
    tags: ["Python", "FastAPI", "LangChain", "Angular", "PostgreSQL"],
    github: "#", // TODO: add real repo link
    demo: "",
    hasDemo: false,
  },
  {
    name: "Aural Eyes",
    blurb:
      "Assistive navigation for visually impaired users — on-device object detection narrated in real time.",
    tags: ["Flutter", "Python", "YOLO11", "Computer Vision"],
    github: "#", // TODO: add real repo link
    demo: "",
    hasDemo: false,
  },
  {
    name: "Quotis",
    blurb:
      "A team-of-five mobile platform for service requests, similar to TaskRabbit — post jobs with multimedia, pick providers by reviews and preferences.",
    tags: ["React Native", "Expo", "Node.js", "Express", "MongoDB", "AWS S3"],
    github: "https://github.com/UofT-UTSC-CS-sandbox/final-term-project-quotis",
    demo: "",
    hasDemo: false,
  },
  {
    name: "ShareSpace",
    blurb:
      "A scalable, database-backed social network for investors — manage friends, share stock lists, and write reviews.",
    tags: ["Python", "Flask", "PostgreSQL", "MongoDB"],
    github: "https://github.com/MealadE/SharesSpace",
    demo: "",
    hasDemo: false,
  },
  {
    name: "Carun",
    blurb:
      "A medium-fidelity mobile prototype, built with a team of 4, for tracking driving mistake history and local driving laws.",
    tags: ["Figma", "UI/UX"],
    github: "#", // TODO: current link is a placeholder — add the real one
    demo: "",
    hasDemo: false,
  },
  {
    name: "CMS HUB",
    blurb:
      "A mobile app, built with a team, for managing content management systems on the go.",
    tags: ["Java", "Android Studio", "Firebase", "JUnit"],
    github: "https://github.com/MustafaTimbawala/B07GR12",
    demo: "",
    hasDemo: false,
  },
];
